import { useCallback, useEffect, useMemo } from 'react'
import { useFetch } from 'civic-champs-shared/api/hooks'

export function usePersonReferences(person, onSuccess) {
  const [request, { loading, error, result }] = useFetch(
    'Error fetching references to person.  Please refresh the page to try again',
  )
  const fetchPersonReferences = useCallback(
    person => {
      return request({
        method: 'get',
        url: `/persons/${person.id}/merge-preview`,
        onSuccess: result => {
          onSuccess && onSuccess(result)
        },
      })
    },
    [request, onSuccess],
  )

  useEffect(() => {
    if (person) {
      fetchPersonReferences(person)
    }
  }, [fetchPersonReferences, person])

  return useMemo(
    () => ({
      loading,
      error,
      result,
    }),
    [loading, error],
  )
}
